import { generateUniqueKeys } from "@/utils/keys";
import { Card, CardContent, CardHeader, Skeleton } from "@st-marketplace/ui";
import type { FC } from "react";

export const SenderInfoDetailsSkeleton: FC = () => {
	const rowCount = 10;

	return (
		<Card>
			<CardHeader>
				<div className="flex items-center gap-3">
					<Skeleton className="size-9 rounded-full" />
					<Skeleton className="h-6 w-[150px]" />
				</div>
			</CardHeader>
			<CardContent className="flex flex-col gap-5">
				{generateUniqueKeys(rowCount).map((key) => (
					<div key={key} className="flex">
						<div className="h-5 w-[35%]">
							<Skeleton className="h-5 w-1/2" />
						</div>
						<div className="h-5 w-[65%]">
							<Skeleton className="h-5 w-full" />
						</div>
					</div>
				))}
			</CardContent>
		</Card>
	);
};

export const SenderInfoDetailsStatusHistorySkeleton: FC = () => {
	return (
		<Card className="h-full">
			<CardHeader>
				<div className="flex items-center gap-3">
					<Skeleton className="size-9 rounded-full" />
					<Skeleton className="h-6 w-[180px]" />
				</div>
			</CardHeader>
			<CardContent className="flex flex-col gap-5">
				{generateUniqueKeys(7).map((key) => (
					<div key={key} className="flex items-center justify-between">
						<Skeleton className="h-8 w-[100px] rounded-md" />
						<Skeleton className="h-5 w-[120px]" />
					</div>
				))}
			</CardContent>
		</Card>
	);
};
